<template>
  <!-- <ScreenAdapter>
 
  </ScreenAdapter> -->
  <div class="fff">
    <Aside></Aside>
    <Header />
    <div class="container">
      <div class="spirit-content" ref="231" v-if="dybyData&&dybyData.length>0">
        <div class="content-header">
          <div class="text">党员榜样</div>
        </div>
        <div class="content-box">
          <div class="content-item" v-for="(item,index) in dybyData" :key="index" @click="jumpDetail(item)">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
          <div class="flex-hide"></div>
        </div>
      </div>

      <div class="accept-content" v-if="xsbyData&&xsbyData.length>0">
        <div class="content-header" ref="108">
          <div class="text">学生榜样</div>
        </div>
        <div class="content-box">
          <div class="item" @click="jumpDetail(item)" v-for="item,index in xsbyData" :key="index">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
// import ScreenAdapter from "@/components/ScreenAdapter"
import services from '@/config/services'
import utils from "../../../../config/utils"
import Aside from "../../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      dybyData: [],
      xsbyData: [],
    }
  },
  async mounted () {
    await this.getListData()
    await this.jumpPosition()
  },
  methods: {
    // 跳转到课程详情
    jumpDetail (item, key) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=example`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          document.body.scrollTop = topVal - 100
        })
      }
    },

    async getListData () {
      await services.getCourseList({ page: 1, size: 2, category_id: "231", school_code: this.school_code }).then(res => {
        this.dybyData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 1, category_id: "232", school_code: this.school_code }).then(res => {
        this.xsbyData = res.data.items
      })
    }
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  }
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 30px;
    // min-height: calc(100vh - 350px);
    overflow: hidden;
    .c-img {
        width: 100%;
        height: 100%;
        transition: all 0.7s;
    }
    .content-header {
        width: 100%;
        height: 25px;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url('../../../../assets/custom/party/index/list-title.png')
            no-repeat center / cover;
        .text {
            font-size: 42px;
            font-weight: bold;
            background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .content-box {
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: space-between;
    }

    .spirit-content {
        position: relative;
        padding: 0 0 30px;
        // &::after {
        //   content: '';
        //   display: inline-block;
        //   position: absolute;
        //   top: -45px;
        //   background: #fffdf7;
        //   width: 100vw;
        //   left: 50%;
        //   height: 711px;
        //   transform: translateX(-50%);
        // }
        .content-header {
            margin: 55px 0 35px;
        }
        .content-box {
            justify-content: space-between;
            .content-item {
                width: 580px;
                height: 327px;
                position: relative;
                overflow: hidden;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
                cursor: pointer;
                &::before {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    background: #b61e2a;
                    width: 100%;
                    height: calc(100% + 60px);
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: -1;
                }
            }
        }
    }

    .accept-content {
        position: relative;
        top: 35px;
        padding: 45px 0 0;
        &::before {
            content: '';
            display: inline-block;
            position: absolute;
            width: 100vw;
            background: url('../../../../assets/hzvtc/list/footer-bg.png')
                no-repeat center/cover;
            height: calc(100% + 15px);
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
        }
        .content-box {
            width: 100%;
            height: 730px;
            background: url('../../../../assets/hzvtc/list/vita-b-news.png')
                no-repeat center/cover;
            position: relative;
            margin-top: -24px;
            .item {
                cursor: pointer;
                width: 817px;
                height: 459px;
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                overflow: hidden;
                .c-img {
                    width: 100%;
                    height: 100%;
                    transition: all 0.7s;
                }
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
        }
        &.zdsx {
            &::before {
                content: '';
                display: inline-block;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 135px;
                width: 100vw;
                height: 650px;
                background: url('../../../../assets/hzvtc/list/profession-bg-c.png')
                    no-repeat center/cover;
            }
            .content-header {
                margin: 20px 0 0;
            }
        }
        &.fzdygzxz {
            .content-header {
                &::before,
                &::after {
                    width: 350px;
                }
            }
        }
    }
}
.fff {
    background: #fff;
}
</style>